import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./hooks/AuthContext";
import DomainRenew from "./components/Tools/DomainRenew.js";

function DomainRenewWrapper() {
  const location = useLocation();

  // Hide on /login and /auth/*
  if (
    location.pathname.startsWith("/auth")
  ) {
    return null;
  }

  return <DomainRenew />;
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <HelmetProvider>
         <DomainRenewWrapper />
        <AuthProvider>
          <App />
        </AuthProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>,

  document.getElementById("root")
);
